import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

// document.addEventListener('change', function(e) {
//   if (e.target && e.target.id === 'customDropdown') {
    
//     const type = e.target.value;
//     const container = document.getElementById('api-results');
    
//     if (!type) {
//       container.innerHTML = '';
//       return;
//     }

//     container.innerHTML = 'Loading...';

//     fetch('https://jsonplaceholder.typicode.com/' + type)
//       .then(res => res.json())
//       .then(data => {
//         container.innerHTML = '';

//         data.forEach(item => {
//           const block = document.createElement('div');
//           block.style.border = '1px solid #ddd';
//           block.style.padding = '10px';
//           block.style.marginBottom = '10px';
//           block.style.borderRadius = '6px';
//           block.textContent = item.title;
//           container.appendChild(block);
//         });
//       })
//       .catch(err => {
//         container.innerHTML = 'Error loading data';
//         console.error(err);
//       });
//   }
// });